import React from 'react';
import axios from 'axios';

import Auxi from '../../hoc/Auxi';
import AppLayout from '../Layout/AppLayout';
import Toast from '../../components/Widgets/CustomToast';


import '../../assets/css/style.css';

class VoiceMailSettings extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            recordType: 'vmail/new',
            voiceMails: [],
            username: "Daniyal",
            loading: false,
            audioSource: '',
            showModal: false,
            data: {},

        };
        this.playPauseRef = [];
    }

    componentDidMount(){
        let mUrl = decodeURIComponent(window.location.href)
        var url = new URL(window.location.href);
        let myCloudId = url.searchParams.get("cloud_id")
        myCloudId = myCloudId.replaceAll("*","");
        this.setState({cloud_id: myCloudId})
        mUrl = mUrl.substring(
            mUrl.lastIndexOf("?username="),
            mUrl.length
        );
        this.setState({url: mUrl});
    }

    render() {

        return(
            <Auxi>
                <AppLayout cloud_id={this.state.cloud_id}
                    display_name = {this.state.username}
                    ownContact = {this.state.ownContact}
                    url={this.state.url}/>

                <div className = "MainIndexApp vmSettingsPage" style={{marginLeft: "0px", marginRight: "0px", marginBottom: "0px"}}>
                    <div className="row voice-message-layout">
                        {/* <object type="text/html" data="https://crexendo-core-021-las.cls.iaas.run/video/" style={{width: "100%", height:"550px"}}>
                        </object> */}

                        <iframe src={`${localStorage.getItem("textableUrl")}/login?ProviderId=${localStorage.getItem("textableProviderId")}&token=${localStorage.getItem("jwtToken")}`} style={{width: "100%",  height: "calc(100vh - 60px)", border:"none"}}></iframe>
                    </div>
                </div>
            </Auxi>

        );

    }

}

export default VoiceMailSettings;
